import { render } from "./CourseItem.vue?vue&type=template&id=20cbbfc8"
import script from "./CourseItem.vue?vue&type=script&lang=js"
export * from "./CourseItem.vue?vue&type=script&lang=js"
script.render = render

export default script